<template>
  <div class="print-page">
    <div class="preview">
      <div class="head">
        <div class="export"></div>
        <img src="@/assets/image/record/paper-1.png" class="paper-1">
        <img src="@/assets/image/record/paper-2.png" class="paper-2">
      </div>

      <van-swipe
        v-if="mode === 'list'"
        class="swiper"
        indicator-color="#fff"
        @change="switchChange"
      >
        <van-swipe-item
          v-for="(item, index) in switchList"
          :key="index"
        >
          <DetailPreview
            v-if="
              (index >= activeIndex - 1 || index <= activeIndex + 1)
              && switchList[index]['renderKeys'] 
              && switchList[index]['renderKeys'].length
            "
            :ref="`detailPreview-${index}`"
            :data="{
              name: switchList[index]['name'],
              size: switchList[index]['size'],
              keys: switchList[index]['renderKeys'],
              tenant_id: switchList[index]['tenant_id']
            }"
          />
        </van-swipe-item>
      </van-swipe>

      <DetailPreview
        v-if="mode === 'single' && renderKeys && renderKeys.length"
        ref="detailPreview"
        :data="{
          name,
          size,
          keys: renderKeys,
          tenant_id
        }"
      />
    </div>
    <div class="keys">
      <div
        v-if="!isAdd"
        class="drag-bar"
        :class="{ reverse: showKeys }"
        @click="showKeys = !showKeys"
      >
        <img v-show="!showKeys" src="@/assets/image/drag.png">
        <img v-show="showKeys" src="@/assets/image/drag-1.png">
      </div>
      <div v-if="!isAdd" class="keys-container" v-show="showKeys">
        <KeyList
          ref="keyList"
          v-if="renderKeys && renderKeys.length"
          :render-keys="renderKeys"
          @update="reRenderPreview"
        />
      </div>
    </div>
    <div class="footer">
      <van-button
        class="primary-blue"
        @click="triggerNumberPicker"
      >
        打印数量：{{printNumber}}
      </van-button>

      <van-button
        type="primary"
        @click="savePrint"
      >{{ printBtnName }}</van-button>
    </div>

    <NumberPicker
      ref="numberPicker"
      v-model="printNumber"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import DetailPreview from '@/components/DetailPreview';
import KeyList from '@/components/keys/List';
import NumberPicker from '@/components/NumberPicker';
import KeysMixin from '@/mixins/keys';
import {
  getTemplateDetail,
  getTemplateOptions
} from '@/api/template';
import {
  getAllPrintDetail,
  tagPrint
} from '@/api/tag';
import {
  userInfo
} from '@/api/system';
import { deviceLocalKey } from '@/config/index';
export default {
  name: 'PrintPage',
  components: {
    DetailPreview,
    KeyList,
    NumberPicker
  },
  mixins:[
    KeysMixin
  ],
  computed: {
    ...mapGetters([ 'user', 'device' ]),
    isAdd() { // 是否为补打
      const {
        query
      } = this.$route

      return !!query.m
    },
    printBtnName() { // 打印按钮文案
      const {
        query
      } = this.$route

      if (query.m) {
        return this.$t('common.rePrint')
      }  {
        return '打印'
      }
    }
  },
  data() {
    return {
      mode: 'single', // single：单个标签（补打、历史记录打印等）， list：模板列表（支持横向切换）
      showKeys: true,
      templateDetail: {},
      tagDetail: {},
      renderKeys: [],
      tagDetailData: {},
      size: '',
      name: '',
      tenant_id: '',
      printNumber: 1,
      activeIndex: 0,
      switchList: [], // 当前swiper渲染需要的数据（从templateData中截取）
    }
  },
  methods: {
    ...mapActions(['setDevice']),
    getTemplateDetail() { // 获取模板数据（PC端模板设计时配置的内容）
      const {
        id
      } = this.$route.params

      return getTemplateDetail(id)
    },
    triggerNumberPicker() {
      const {
        numberPicker
      } = this.$refs

      numberPicker && numberPicker.open()
    },
    requiredValidate() {
      // 必填校验
      let validate = true
      const requiredKeys = this.allKeys.filter(i => i.required).map(i => i.apiKey)
      const inListKeys = this.renderKeys.filter(i => requiredKeys.includes(i.key))
      const notConfigedKeys = inListKeys.filter(i => 
        {
          const keysItem = this.allKeys.find(a => a.apiKey === i.key)
          if (keysItem && keysItem.apiTextKey) {
            return !i.value && !i.text
          } else {
            return !i.value
          }
        }
      )
      
      
      let illegalKeys = []
      if (notConfigedKeys.length) {
        validate = false
        illegalKeys = illegalKeys.concat(notConfigedKeys.map(i => i.describe))
      }

      if (illegalKeys.length) {
        this.$Toast.fail(`${illegalKeys.join('、')}是必填的`)
      }

      return validate
    },
    checkUserTenant() {
      // 检查用户租户是否一致（只有honjo账号会用到）
      return new Promise(resolve => {
        const {
          ins_tenant_id
        } = this.user
        if (!ins_tenant_id) {
          resolve(true)
        } else {
          userInfo()
          .then(res => {
            if (res) {
              resolve(res.tenant_id === ins_tenant_id )
            } else {
              resolve(false)
            }
          })
        }
      })
    },
    checkTemplateStatus() {
      // 检查模版状态（是否禁用）
      const tag_id = this.mode === 'single' ? this.$route.params.id : this.switchList[this.activeIndex]['id']
      
      return new Promise(resolve => {
        getTemplateDetail(tag_id)
        .then(res => {
          if (res && !res.is_delete) {
            resolve(true)
          }

          resolve(false)
        })
      })
    },
    async savePrint() {
      // 打印功能入口
      // 校验版本号（当功能更新后并且需要app包同步更新时，需要修改下面参数的版本号）
      const versionStatus = this.$utils.app.limitVersion('1.0.6')
      if (!versionStatus) return
      // 校验模板是否被禁用
      const templateStatus = await this.checkTemplateStatus()
      if (!templateStatus) {
        this.$Toast.fail('该标签模版已被禁用，无法打印！')

        return
      }
      // 校验租户是否发生变化（目前只有红柚超级管理员在PC端有切换租户功能）
      const tenantStatus = await this.checkUserTenant()
      if (!tenantStatus) {
        this.$Toast.fail('租户发生变化，请重启app后再试')
        
        return
      }
      // 校验app是否有在连接状态的打印机
      if (!this.device || !this.device.address) {
        this.$Toast.fail('请先连接打印机')

        return
      }
      // 校验当前打印机上次连接的设备是否为当前设备
      const { code: lastConnectStatus, info } = await this.$utils.device.getLastConnectInfo(this.device)
      if (lastConnectStatus === 2) {
        return
      } else if (lastConnectStatus === 1 && info.device_id) {
        const { created_name, device_brand, device_model } = info
        localStorage.removeItem(deviceLocalKey)
        this.setDevice({})

        this.$dialog
        .alert({
          message: `打印机已被${created_name}（${device_brand}-${device_model}）连接，请重新连接`
        })
        .then(() => {
          this.$router.push('/device')
        })
        
        return
      }
      // 打印时模板必填字段校验
      const validate = this.requiredValidate()
      if (!validate) return
      // 先保存打印记录（获取流水号）之后，进行渲染和打印
      this.save().then((saved) => {
        if (saved) {
          const serial = this.renderKeys.find(i => i.type === 'serial_number')
          if (serial) {
            serial.text = saved
            this.reRenderPreview()
          }
          this.$utils.generatePrintData(this.renderKeys, this.size).then(res => {
            if (res) {
              const data = Object.assign(res, { printNumber: this.printNumber })
              this.sendPrintToPrinter(data)
            }
          })
        }
      })
    },
    sendPrintToPrinter(data) {
      data.size = this.$utils.matchTagSize(this.size).split('x')
      // 发送打印指令到打印机
      const config = {
        event: 'printTag',
        params: { printData: data },
        // callback: this.connectResult
      }

      this.$utils.app.sendAppMsg(config)
    },
    save() {
      // 保存打印数据
      const content = JSON.stringify(this.renderKeys)
      const {
        id
      } = this.$route.params

      const printId = this.tagDetailData && this.tagDetailData.id
      const tag_id = this.mode === 'single' ? id : this.switchList[this.activeIndex]['id']

      const info = {
        tag_id,
        num: this.printNumber,
        content,
        print_uid: this.user.id,
        id: this.isAdd ? printId : undefined
      }

      const detail = {}
      this.renderKeys.forEach(i => {
        if (i.type !== 'list') {
          detail[i.key] = i.value
          const keysItem = this.allKeys.find(a => a.apiKey === i.key)
          const apiTextKey = keysItem ? keysItem['apiTextKey'] : ''
          if (apiTextKey && i.text) {
            detail[apiTextKey] = i.text
          }
        }
      })

      const params = Object.assign(
        {
          platform:'2',
          device_id:this.$store.getters.appInfo.deviceId || '',
          bluetooth_address:this.$store.getters.device.address || '',
        }, detail, info
      )

      return tagPrint(params)
      .then(res => {return res.serial_number || null})
    },
    getTagDetail() {
      // 获取标签详情（包含打印数据）
      return new Promise(resolve => {
        const { t } = this.$route.query

        if (t && Number(t)) {
          getAllPrintDetail(t)
          .then(res => {
            if (res) {
              this.tagDetailData = res
              resolve(res)
            } else {
              resolve(null)
            }
          })
        } else {
          resolve(null)
        }
      })
    },
    reRenderPreview() {
      // 根据内容渲染标签封面图
      if (this.mode === 'single') {
        const {
          detailPreview
        } = this.$refs

        detailPreview && detailPreview.renderImage()
      } else if (this.mode === 'list') {
        const previewInstance = this.$refs[`detailPreview-${this.activeIndex}`]

        previewInstance[0] && previewInstance[0].renderImage()
      }
    },
    bySingleTag() {
      // 通过单个标签记录渲染
      Promise.all([this.getTemplateDetail(), this.getTagDetail()])
      .then(res => {
        if (res) {
          const templateDetail =res[0]
          const tagDetail = res[1]

          if (!templateDetail || !templateDetail.content) {
            this.$Toast.fail('无法找到模板数据，请联系管理员')
            return
          }

          try {
            this.size = templateDetail.size
            const templateKeys = JSON.parse(templateDetail.content)
            const tagContent = tagDetail && tagDetail.content ? tagDetail.content : null
            const tagKeys = tagContent ? JSON.parse(tagContent) : null
            const renderKeys = tagKeys || templateKeys
            this.name = tagDetail ? tagDetail.tag_name : templateDetail.name
            this.renderKeys = renderKeys            
            this.tenant_id = templateDetail ? templateDetail.tenant_id : 0
          } catch (error) {
            console.error('解析模板出错:', error)
          }
        }
      })
    },
    getTemplatedata() {
      return getTemplateOptions()
    },
    getTemplateList() {
      // 查询模板列表
      return this.getTemplatedata()
      .then(res => {
        if (res) {
          this.switchList = res || []
        }
      })
    },
    async byTemplateList() {
      // 通过模板列表渲染
      await this.getTemplateList()
      if (!this.switchList || !this.switchList.length) {
        this.$Toast.fail('没有可用的模板，请联系管理人员。')
        return
      }
      this.activeIndex = 0
      await this.getRenderKeys(this.switchList[this.activeIndex])
      this.getPrevAndNextRenderKeys(this.activeIndex)

      if (this.switchList[this.activeIndex] && this.switchList[this.activeIndex]['renderKeys']) {
        this.renderKeys = this.switchList[this.activeIndex]['renderKeys']
        this.size = this.switchList[this.activeIndex]['size']
      }
    },
    async getRenderKeys(switchListItem) {
      // 获取指定模板的数据并将数据转换为页面渲染和处理所需的格式和字段
      return new Promise(resolve => {
        if (switchListItem && !switchListItem.renderKeys) {
          try {
            getTemplateDetail(switchListItem.id)
            .then(detail => {
              const keys = JSON.parse(detail.content)
              const { size, tenant_id } = detail

              this.$set(switchListItem, 'renderKeys', keys)
              this.$set(switchListItem, 'size', size)
              this.$set(switchListItem, 'tenant_id', tenant_id)
              this.$nextTick(() => {
                resolve(true)
              })
            })
          } catch (error) {
            console.error('解析模板出错')
            resolve(false)
          }
        }
      })
    }, 
    async getPrevAndNextRenderKeys(index) {
      const prev = this.switchList[index - 1]
      const next = this.switchList[index + 1]
      this.getRenderKeys(prev)
      this.getRenderKeys(next)
    },
    switchChange(index) {
      // 切换模板方法
      this.renderKeys = []
      this.activeIndex = Number(index)
      this.getPrevAndNextRenderKeys(this.activeIndex)
      const item = this.switchList[this.activeIndex]
      const { 
        renderKeys,
        size
       } = item
       if (renderKeys && renderKeys.length) {
        this.renderKeys = renderKeys
        this.size = size
        this.$nextTick(()=>{ // 使用nextTick执行的原因是，因为代码异步的原因，上一个模板的灭菌时间值还没有被清除，所以说会被setSterilizationTime方法return掉。所以使用nextTick等灭菌时间被清除了以后再调用。
          let keyList = this.$refs.keyList
          keyList.setSterilizationTime()
        })
       } else {
        this.$Toast.fail('未找到模板内容，请联系管理员。')
       }
    },
    init() {
      // 初始化方法，根据页面调用位置确定模式及后续处理的方法
      const {
        path
      } = this.$route
      let mode = 'single'
      if (path.startsWith('/template')) {
        mode = 'list'
      }
      this.mode = mode

      if (mode === 'single') {
        this.bySingleTag()
      } else if (mode === 'list') {
        this.byTemplateList()
      }
    }
  },
  created() {
    this.init()
  }
}
</script>

<style lang="less" socped>
  .print-page {
    display: flex;
    flex-direction: column;
    height: 100vh;
    .preview {
      padding: 0 64px;
      height: 716px;
      .head {
        height: 46px;
        position: sticky;
        top: 0;
        margin-bottom: -1px;
        .export {
          width: 100%;
          height: 34px;
          background-color: @primary-color-1;
          border-radius: 17px;
          position: absolute;
          top: 0;
        }
        .paper-1, .paper-2 {
          position: absolute;
          width: 100%;
          top: 16px;
        }
        .paper-1 {
          height: 30px;
        }
        .paper-2 {
          height: 44px;
        }
      }
      .swiper {
        height: 670px;
        .van-swipe__indicators {
          bottom: 2px;
          .van-swipe__indicator {
            background-color: rgba(255, 255, 255, 0.5);
          }
        }
      }
    }
    .keys {
      flex: 1;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      .drag-bar {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px 0;
        height: 92px;
        transform: rotate(180deg);
        img {
          width: auto;
          height: 52px;
        }
        &.reverse {
          transform: rotate(0deg);
        }
      }
      .keys-container {
        padding: 60px 64px;
        flex: 1;
        overflow-x: hidden;
        overflow-y: auto;
      }
    }
    .footer {
      padding: 10px 64px;
      width: 100%;
      flex-shrink: 0;
      display: flex;
      justify-content: center;
      // gap: 20px;
      .flexgap(20px, row);
      .primary-blue {
        background-color: @primary-color-2;
        color: #fff;
        border-color: @primary-color-2;
      }
      .van-button {
        flex: 1;
        border-radius: 6px;
      }
    }
  }
</style>